import { instance } from "@/api/index";


function getFaqList(params) {
    return instance.get("/customers/faq-list", { params: params });
}

export {
    getFaqList,
}